import axios from 'axios';
import * as Sentry from '@sentry/react';
import { resolveApiBaseUrl } from 'api/resolveApiBaseUrl';
import { withIdToken } from 'utils/server';
export * from './TakeAway';

declare module 'axios' {
  export interface AxiosRequestConfig {
    expectedErrorStatuses?: number[];
  }
}

// REACT_APP_API_URL is the same override utils/server already honours: without
// it every non-prod build (staging, a local run against the backup project)
// falls through to the live API.
const API_URL_OVERRIDE = (process.env.REACT_APP_API_URL || '').trim().replace(/\/+$/, '');
const baseURL = resolveApiBaseUrl(
  process.env.REACT_APP_USE_EMULATOR,
  process.env.REACT_APP_API_TARGET,
  API_URL_OVERRIDE,
);

const server = withIdToken(
  axios.create({
    baseURL,
    timeout: 15000,
    headers: { 'X-Custom-Header': 'dashboard' },
  }),
);

server.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const expectedErrorStatuses: number[] = error.config?.expectedErrorStatuses ?? [];
    if (status !== 401 && status !== 403 && !expectedErrorStatuses.includes(status)) {
      Sentry.captureException(error, {
        tags: {
          api_endpoint: error.config?.url,
          http_status: status ?? 'network_error',
        },
        contexts: {
          http: {
            method: error.config?.method?.toUpperCase(),
            url: error.config?.url,
            status_code: status,
          },
        },
      });
    }
    return Promise.reject(error);
  },
);

export default server;
